export default __webpack_public_path__ + "static/banners_cert-ef85c45ef60f93efadc21b174ea11e08.png";